var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: -1365.333,
    y1: -964.901,
    x2: -1364.333,
    y2: -964.901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: 99.957,
    y1: 38.479,
    x2: 125.843,
    y2: 38.479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M101.207 38.479h23.386"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: 99.224,
    y1: 44.285,
    x2: 119.817,
    y2: 44.285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M100.474 44.285h18.093"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: 97.514,
    y1: 74.635,
    x2: 123.4,
    y2: 74.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.764 74.635h23.386"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: 96.781,
    y1: 80.442,
    x2: 117.374,
    y2: 80.442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.031 80.442h18.093"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: 94.094,
    y1: 108.837,
    x2: 119.979,
    y2: 108.837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M95.344 108.837h23.385"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879",
    gradientUnits: "userSpaceOnUse",
    x1: 93.361,
    y1: 114.644,
    x2: 113.953,
    y2: 114.644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_c4dc2101167551c3cbebd3e0b61237062cc6f9b9621d467339a0958a21f63879)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M94.611 114.644h18.092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M57.405 17.663h79.886l-10 116.532H47.405zM128.513 120.107h17.724l-8.763-102.118"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M81.469 39.171s-.495-2.864-2.864-2.864c-2.369 0-3.005 2.864-3.005 2.864l6.152 4.664M75.882 43.835s.495 2.864 2.864 2.864c2.369 0 3.005-2.864 3.005-2.864M78.675 33.868v2.439M78.675 46.699v2.44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M81.469 39.171s-.495-2.864-2.864-2.864c-2.369 0-3.005 2.864-3.005 2.864l6.152 4.664M75.882 43.835s.495 2.864 2.864 2.864c2.369 0 3.005-2.864 3.005-2.864M78.675 33.868v2.439M78.675 46.699v2.44"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 78.675,
    cy: 41.361,
    r: 13.848
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 75.744,
    cy: 76.54,
    r: 13.848
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 72.812,
    cy: 110.986,
    r: 13.848
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M77.772 71.092s-.961-1.21-2.706-1.104c-2.385.214-2.67 2.884-1.66 6.321.805 3.291-2.079 5.575-2.079 5.575h7.37l-.094-2.551M73.464 75.97h2.456"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M77.772 71.092s-.961-1.21-2.706-1.104c-2.385.214-2.67 2.884-1.66 6.321.805 3.291-2.079 5.575-2.079 5.575h7.37l-.094-2.551M73.464 75.97h2.456M66.499 109.317h5.328M66.499 112.92h5.328M76.604 107.322s-.794-2.077-2.998-2.26c-2.996-.375-4.569 2.472-4.719 5.917-.15 3.445 1.049 6.217 4.119 6.217 2.437.081 3.597-2.362 3.597-2.362M66.499 109.317h5.328M66.499 112.92h5.328"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M76.604 107.322s-.794-2.077-2.998-2.26c-2.996-.375-4.569 2.472-4.719 5.917-.15 3.445 1.049 6.217 4.119 6.217 2.437.081 3.597-2.362 3.597-2.362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeRates);
export default __webpack_public_path__ + "static/media/exchangeRates.5d5885d3a0a4f83a576b32528c4ee04a.svg";
export { ForwardRef as ReactComponent };